import CreateLoadGroup from "./CreateLoadGroup";

export default CreateLoadGroup;